import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    contactId: z.string(),
  }),
  response: z.void(),
};
